<div class="flex flex-col sm:flex-row sm:items-center gap-3">
  <!-- Desktop: select button -->
  <div class="hidden sm:block">
    <p-selectbutton [options]="quickOptions" [(ngModel)]="selectedQuickFilter" optionLabel="label" optionValue="value" (onChange)="selectFilter($event.value)" [allowEmpty]="false" />
  </div>

  <!-- Mobile: dropdown -->
  <div class="sm:hidden">
    <p-select [options]="quickOptions" [(ngModel)]="selectedQuickFilter" optionLabel="label" optionValue="value" (onChange)="selectFilter($event.value)" class="w-full" />
  </div>

  <p-datepicker
    [(ngModel)]="rangeDates"
    selectionMode="range"
    [readonlyInput]="!isCustomRange"
    [disabled]="!isCustomRange"
    [showIcon]="isCustomRange"
    dateFormat="dd/mm/yy"
    [placeholder]="isCustomRange ? 'Seleccionar rango' : ''"
    [numberOfMonths]="isCustomRange ? 1 : 2"
    (onSelect)="onRangeSelect()"
    inputStyleClass="text-sm"
    [style]="{'min-width': '250px', 'width': '100%'}"
    styleClass="sm:w-auto"
  />
</div>
